<template> 
  <div id="app"> 
    <keep-alive> 
      <router-view v-if="$route.meta.keepAlive"> 
        <!-- 这里是会被缓存的视图组件 --> 
      </router-view> 
    </keep-alive> 
    <router-view v-if="!$route.meta.keepAlive"> 
      <!-- 这里是不被缓存的视图组件， --> 
    </router-view> 
    <!-- <router-view/> --> 
    <imgPreview></imgPreview>
    

  </div> 
</template> 
<script>
import imgPreview from '@/common/module/previewImg'
  export default {
    mounted(){
      
    },
    components: {
        imgPreview
    }
  }
</script>
<style lang='scss'> 
  @import "./common/css/common.scss"; 
</style> 


// WEBPACK FOOTER //
// src/App.vue